module.exports = __webpack_public_path__ + "static/media/reglamento_1.3396da6a.png";